import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { personasApi } from '../api/personas.api'
import type { PersonaFormData } from '../types'

const PERSONAS_KEY = ['personas'] as const

export function usePersonas() {
  return useQuery({
    queryKey: PERSONAS_KEY,
    queryFn: () => personasApi.fetchAll().then((r) => r.data.data),
  })
}

export function useCreatePersona() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (data: PersonaFormData) => personasApi.create(data),
    onSuccess: () => qc.invalidateQueries({ queryKey: PERSONAS_KEY }),
  })
}

export function useUpdatePersona() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: PersonaFormData }) =>
      personasApi.update(id, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: PERSONAS_KEY }),
  })
}

export function useDeletePersona() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => personasApi.remove(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: PERSONAS_KEY }),
  })
}

export function useSetDefaultPersona() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => personasApi.setDefault(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: PERSONAS_KEY }),
  })
}
